export default __webpack_public_path__ + "static/media/employment_bg_large.311dd177.jpg";